import React from 'react'
import { GLOBAL_CONTEXT } from '../utils'

export const GlobalContext = Object.assign(React.createContext(GLOBAL_CONTEXT), { GLOBAL_CONTEXT })
